import { render, staticRenderFns } from "./TransferAccounts.vue?vue&type=template&id=0f23e4d9&scoped=true&"
import script from "./TransferAccounts.vue?vue&type=script&lang=js&"
export * from "./TransferAccounts.vue?vue&type=script&lang=js&"
import style0 from "./TransferAccounts.vue?vue&type=style&index=0&id=0f23e4d9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f23e4d9",
  null
  
)

export default component.exports